import { useContext } from 'react';

import { VersionContext } from './version-context';

export const useNewVersionAvailable = () => {
  const { newVersionAvailable } = useContext(VersionContext);

  return newVersionAvailable;
};
